import { useEffect, useState } from "react";

import { useShouldDisplayPromotionalBanner } from "../useShouldDisplayPromotionalBanner/useShouldDisplayPromotionalBanner";
import { useTrack } from "../useTrack/useTrack";

export function useTrackBanner() {
  const [hasBeenTracked, setHasBeenTracked] = useState(false);
  const shouldDisplayPromotionalBanner = useShouldDisplayPromotionalBanner();
  const { track } = useTrack();

  useEffect(() => {
    if (shouldDisplayPromotionalBanner && !hasBeenTracked) {
      track("notification_displayed", {
        initiative: "ai_add_on",
      });
      setHasBeenTracked(true);
    }
  }, [hasBeenTracked, track, shouldDisplayPromotionalBanner]);

  const handleClick = () => {
    track("notification_open", {
      initiative: "ai_add_on",
    });
  };

  return {
    handleClick,
  };
}
